import script from "./MessageBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageBox.vue?vue&type=script&setup=true&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=6b067d8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b067d8b"]])

export default __exports__